import CreateStoreDetailDto from "~/models/CreateStoreDetailDto";
import DtoObject from "~/models/DtoObject";

export default class CreateStoreDto extends DtoObject<CreateStoreDto> {
  vendorCustomerStoreId: string = "";
  storeDetail: CreateStoreDetailDto = new CreateStoreDetailDto();

  constructor(createStoreDtoPart: Partial<CreateStoreDto> = {}) {
    super();
    Object.assign(this, createStoreDtoPart);
  }

  static testValuesFactoryAllNull() {
    return new CreateStoreDto({
      vendorCustomerStoreId: "HBfeeMqlxTBzwVypDOuzMvHhdfUGLrNG",
      storeDetail: new CreateStoreDetailDto(),
    });
  }

  static testValuesFactorySomeNull() {
    return new CreateStoreDto({
      vendorCustomerStoreId: "zKMgNGiSfiweLsEeSVVgUCIpjAcOWMRe",
      storeDetail: new CreateStoreDetailDto(),
    });
  }

  static testValuesFactoryNoneNull() {
    return new CreateStoreDto({
      vendorCustomerStoreId: "EnGndRWUGanghUHUuoYaYaDRmmKpGTPo",
      storeDetail: new CreateStoreDetailDto(),
    });
  }
}
